import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DWInitiateCashTransactionRequest } from 'src/app/shared/models/DWInitiateCashTransactionRequest.model';
import { transferCarrier } from 'src/app/shared/models/payouttokens.model';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-transfer-requested',
  templateUrl: './transfer-requested.component.html',
  styleUrls: ['./transfer-requested.component.scss']
})

export class TransferRequestedComponent implements OnInit{

transferDate:any;
transactionRefNo:any;
transfer:transferCarrier=new transferCarrier();
errorMessage:any;
isPPI: boolean = false;

  constructor(
    public route:Router,
    private sessionService: SessionService
  ) {}


  ngOnInit(){
    const datepipe: DatePipe = new DatePipe('en-US');
    this.transferDate = datepipe.transform(new Date, 'MM/dd/YYYY');
    this.transfer=JSON.parse(sessionStorage.getItem('transferCarrier') || '{}');
    this.transactionRefNo=sessionStorage.getItem('transactionRefNo');
    this.errorMessage = sessionStorage.getItem('errorMsg');

    this.isPPI = this.sessionService.isPPI();
  }

goToHome(){
  this.route.navigate(['home']);
}

}
